import { ITheme } from 'interfaces/styled';
import { FontFamilies, Colors, Media } from 'enums';

export const baseTheme: ITheme = {
  colors: {
    yellow1: Colors.yellow1,
    yellow2: Colors.yellow2,
    yellow3: Colors.yellow3,

    gray1: Colors.gray1,
    gray2: Colors.gray2,
    gray3: Colors.gray3,
    gray4: Colors.gray4,

    red1: Colors.red1,
    red2: Colors.red2,

    hover_links: Colors.hover_links,
    background: Colors.background,
    card: Colors.card,
    white: Colors.white,
    label_color: Colors.label_color,
  },

  media: {
    mobile: Media.mobile,
    tablet: Media.tablet,
    notebook: Media.notebook,
    desktop: Media.desktop,
  },

  text: {
    fontFamily: {
      inter: FontFamilies.Inter,
      roboto: FontFamilies.Roboto,
    },
  },
};
